import {Switch} from 'platform/components';
import {Box, Hide, HStack, Icon, Image, Show, Space, Text} from 'platform/foundation';

import {Link} from 'react-router-dom';

import {isNil} from 'ramda';

import {PlatformCode} from '@dms/api/shared';
import {settingsRoutes, testIds} from '@dms/routes';
import {platformImageURLs} from '@dms/shared';
import {Platform} from '@dms/teas';

import {composePath, getSafely} from 'shared/web';

import {SwitchWrapper} from '../../VehicleServices/components/styles';

interface AdvertisementPlatformRowProps {
  platform: Partial<Platform>;
  isFirst?: boolean;
  isFake?: boolean;
  handleStatusChange?: (platformCode: PlatformCode, enabled: boolean) => void;
}

const platformLink = (code?: string) =>
  composePath(settingsRoutes.advertisingPlatformsDetail, {
    params: {code},
  });

export function AdvertisementPlatformRow(props: AdvertisementPlatformRowProps) {
  return (
    <Link
      key={props.platform.code}
      to={platformLink(props.platform.code)}
      data-testid={testIds.settings.advertisingPlatforms(`link-platform-${props.platform.code}`)}
    >
      <Box
        height={10}
        paddingHorizontal={4}
        borderTop={!props.isFirst ? '1px solid' : 'none'}
        borderColor="palettes.neutral.40.100"
      >
        <HStack height="100%" align="center">
          <SwitchWrapper
            onClick={(e) => e.stopPropagation()}
            data-testid={testIds.settings.advertisingPlatforms(
              `switchWrapper-${props.platform.code}`
            )}
          >
            <Switch
              value={props.isFake ? false : !!props.platform.enabled}
              onChange={(value) => {
                if (props.isFake || !props.handleStatusChange) {
                  return;
                }
                props.handleStatusChange(props.platform.code as PlatformCode, value);
              }}
              isDisabled={props.isFake || !props.platform.hasCredentials}
              data-testid={`switcher-platform-${props.platform.code}`}
            />
          </SwitchWrapper>

          <Hide
            when={isNil(props.platform.code && getSafely(platformImageURLs, props.platform.code))}
          >
            <Image
              src={props.platform.code && getSafely(platformImageURLs, props.platform.code)}
              alt={props.platform.title}
              height={4}
              data-testid={testIds.settings.advertisingPlatforms(`logo-${props.platform.code}`)}
            />
          </Hide>
          <Show
            when={isNil(props.platform.code && getSafely(platformImageURLs, props.platform.code))}
          >
            <Text
              data-testid={testIds.settings.advertisingPlatforms(`logo-${props.platform.code}`)}
            >
              {props.platform.title}
            </Text>
          </Show>

          <Space fillAvailable />
          <Icon value="navigation/chevron_right" />
        </HStack>
      </Box>
    </Link>
  );
}
